module.exports = __webpack_public_path__ + "static/media/Reward-coin.f5888eb0.png";